import { render, staticRenderFns } from "./CategoriesForm.vue?vue&type=template&id=50c1ca50&scoped=true"
import script from "./CategoriesForm.vue?vue&type=script&lang=js"
export * from "./CategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./CategoriesForm.vue?vue&type=style&index=0&id=50c1ca50&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1ca50",
  null
  
)

export default component.exports